/**
 * LanguageProgressStrip — compact "Languages ready: 3/14" indicator for
 * Studio library cards. One tiny segment per language, coloured by status.
 */
import { Languages } from "lucide-react";

const SEGMENT_CLASS = {
  done: "bg-[color:var(--accent)]",
  processing: "bg-amber-400/80 animate-pulse",
  failed: "bg-red-500/60",
  pending: "bg-white/10",
};

export default function LanguageProgressStrip({ languages, videoId }) {
  const entries = Object.entries(languages || {});
  if (entries.length < 2) return null;
  const done = entries.filter(([, l]) => l?.status === "done").length;
  return (
    <div className="mt-2" data-testid={`language-progress-strip-${videoId}`}>
      <div className="flex items-center justify-between text-[10px] uppercase tracking-[0.18em] text-[color:var(--muted)]">
        <span className="inline-flex items-center gap-1">
          <Languages className="w-3 h-3" /> Languages ready
        </span>
        <span data-testid={`language-progress-count-${videoId}`}>
          {done}/{entries.length}
        </span>
      </div>
      <div className="mt-1 flex gap-[2px] h-1.5">
        {entries.map(([code, l]) => (
          <div
            key={code}
            className={`flex-1 rounded-sm ${SEGMENT_CLASS[l?.status] || SEGMENT_CLASS.pending}`}
            title={`${code.toUpperCase()} · ${l?.status || "pending"}`}
          />
        ))}
      </div>
    </div>
  );
}
